import React from "react";
import I18n from "../../i18n/I18n";
import styles from "./Notification.scss";
import { Dropdown, Button } from "../common/index";

type Props = {
    lang: Array<Object>,
    user: Array<Object>,
    onChange: Function,
    onPrefSubmit: Function,
    postLoading: boolean,
    isPreferenceLoading: boolean
};

const Notification = (props: Props) => {
    const {
        lang,
        notPref,
        langSelected,
        notfSelected,
        onChange,
        onPrefSubmit,
        postLoading,
        isPreferenceLoading
    } = props;
    return (
        <div className={styles.columnWrapper}>
            <div className={styles.columnCtr}>
                <div className={styles.inputWrapper}>
                    <p className={styles.inputTitle}>
                        {I18n.getText(
                            "settings.notf-pref",
                            {},
                            "Notification Preference"
                        )}
                    </p>
                    <div className={styles.dropWrapper}>
                        <Dropdown
                            name={"pref"}
                            value={notfSelected}
                            options={notPref}
                            onChange={e => onChange(e, "prefNotOption")}
                            placeholder={isPreferenceLoading ? 'Loading....' : ''}
                        />
                    </div>
                </div>
                <div className={styles.inputWrapper}>
                    <p className={styles.inputTitle}>
                        {I18n.getText(
                            "settings.lang-pref",
                            {},
                            "Language Preference"
                        )}
                    </p>
                    <div className={styles.dropWrapper}>
                        <Dropdown
                            name={"lang"}
                            value={langSelected}
                            options={lang}
                            onChange={e => onChange(e, "prefLanguage")}
                            placeholder={isPreferenceLoading ? 'Loading....' : ''}
                        />
                    </div>
                </div>
            </div>
            <div className={styles.btnWrapper}>
                <Button
                    className={styles.ctaBtn}
                    variant="primary"
                    onClick={onPrefSubmit}
                >
                    {postLoading ? (
                        <div className={styles.loader} />
                    ) : (
                        I18n.getText("settings.btn-submit", {}, "Submit")
                    )}
                </Button>
            </div>
        </div>
    );
};

export default Notification;



// WEBPACK FOOTER //
// ./src/components/settings/Notification.js